import React, { FunctionComponent, ReactNode } from "react"
import { SettingsPageUrl } from "./SettingsNavMenu"
import { DropdownItem } from "reactstrap"
import { History } from "history"


    
interface SettingsMenuItemProps {
    page: SettingsPageUrl
    label: string
    children?: ReactNode
    history: History
}

export const SettingsNavMenuItem: FunctionComponent<SettingsMenuItemProps> = (props: SettingsMenuItemProps) => {
        const { page, label, children, history } = props
        return (
            <DropdownItem
                className="btn"
                onClick={() => 
                    history.push(`/settings/${page}`    
                )}
            >
                { label }
                { children }
            </DropdownItem>
        )
    }